import { DEFAULT_TOAST_MESSAGE } from './constants';

export const getErrorMessageLinkManagement = (errorMessage: string) => {
  switch (errorMessage) {
    default:
      return DEFAULT_TOAST_MESSAGE.UPDATE.ERROR;
  }
};

export const convertDataToNumberic = (objectData: Record<string, string>) => {
  return Object.fromEntries(Object.entries(objectData).map(([key, value]) => [key, Number(value)]));
};
